import { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { apiCall } from '~/providers';
import { FullProg_v4 } from '~/providers/types';
import { Title } from '../../DEVs/styles';
import { ButtonShowSchedule } from '../../SchedulesModals/components/ButtonShowSchedule';
import { DamScheduleSummaryModal } from './Modal';

interface DamScheduleSummaryProps {
  damId: string;
  status?: string;
}

export function DamScheduleSummary({
  damId,
  status,
}: Readonly<DamScheduleSummaryProps>): ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [prog, setProg] = useState<FullProg_v4>();
  const { t } = useTranslation();

  function onClickShowSchedule(): void {
    setShowModal(true);
  }

  function onCloseSchedulesModal(): void {
    setShowModal(false);
  }

  async function getData() {
    try {
      setIsLoading(true);
      if (damId) {
        const data = await apiCall('/dam/get-programming-v3', { damId });
        setProg(data);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('houveErro'));
    }
    setIsLoading(false);
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {showModal && prog && (
        <DamScheduleSummaryModal
          prog={prog}
          onClose={onCloseSchedulesModal}
          pendingProg={status !== 'ONLINE'}
        />
      )}
      <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 20 }}>
        <Title>{t('funcionamento')}</Title>
        <ButtonShowSchedule
          loading={isLoading}
          onClick={onClickShowSchedule}
        />
      </div>
    </>
  );
}
